// extracted by mini-css-extract-plugin
export default {"container":"Rewards_container__8X9R3","dividerText":"Rewards_dividerText__IXN+F"};